import {formatSimmsDateTime} from "../../../components/commonmethod/CommonMethod";
import {RatedStart} from "../../serviceRequest/serviceRequest/subpage/ServiceStarRating";

export function resolveReportColWidth(col) {
    if (col.widthPct) {
        return col.widthPct;
    }
    if (typeof col.width === "number") {
        return `${col.width}px`;
    }
    return col.width;
}

export function renderReportCell(item, col) {
    if (col.type === "feedback") {
        if (item[col.field] === 0) {
            return null;
        }
        return (
            <RatedStart
                defaultValue={item[col.field]}
                className="justify-center"
            />
        );
    }

    if (Array.isArray(col.field)) {
        return col.field.map((fieldKey, fieldIndex) => {
            const label = col.label?.[fieldIndex] ?? "";
            const raw = item[fieldKey];
            const text = col.type === "dateArray" && typeof raw === "string"
                ? formatSimmsDateTime(raw)
                : (raw ?? "");
            return (
                <p key={`${fieldKey}-${fieldIndex}`} className="m-0 leading-snug">
                    {label}{text}
                </p>
            );
        });
    }

    if (col.type === "date") {
        return formatSimmsDateTime(item[col.field]);
    }

    return item[col.field];
}
